import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { ToastPayload, ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: false,
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss']
})
export class ToastComponent implements OnInit, OnDestroy {
  toast: ToastPayload | null = null;
  fadeMs = 300;
  holdMs = 1200;

  private sub?: Subscription;
  private clearSub?: Subscription;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.sub = this.toastService.toast$.subscribe((toast) => {
      this.clearSub?.unsubscribe();

      if (!toast) {
        this.toast = null;
        return;
      }

      this.toast = toast;
      this.fadeMs = toast.fadeMs ?? 300;
      this.holdMs = toast.durationMs ?? 1200;

      const total = this.fadeMs + this.holdMs + this.fadeMs;
      this.clearSub = timer(total).subscribe(() => {
        this.toastService.clear();
      });
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.clearSub?.unsubscribe();
  }
}
